export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/life_coaching.337cf65.svg";